export default function ({ ...props }) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <g opacity="0.5">
                <circle cx="14" cy="14" r="13" stroke="white" strokeWidth="2" />
                <path
                    d="M11 9.04464C11 8.21249 11.9571 7.7444 12.6139 8.25529L19.4926 13.6053C19.7499 13.8055 19.7499 14.1945 19.4926 14.3947L12.6139 19.7447C11.9571 20.2556 11 19.7875 11 18.9554V9.04464Z"
                    fill="white"
                />
            </g>
        </svg>
    );
}
